import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { PdvService } from '@app/services/pdv/pdv.service';
@Component({
    selector: 'app-zone',
    templateUrl: 'zone.component.html',
    styleUrls: ['zone.component.scss']
})
export class ZoneComponent implements OnInit {
    family = "";
    zone = "";
    postalCode = "";
    host = "";
    pdv = "";
    authorizedCities: any[] = [];
    constructor(private pdvService: PdvService, private route: ActivatedRoute,
        @Inject(PLATFORM_ID) private platformId: Object) {

    }
    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params['zone']) {
                let pra = params['zone'].split('-');
                this.family = pra[1];
                this.postalCode = pra[pra.length - 1];
                pra.splice(0, 1)
                pra.splice(1, 1)
                pra.splice(pra.length - 1, 1)
                this.zone = pra.join('-');
                if (isPlatformBrowser(this.platformId)) {
                    this.host = window.location.hostname;
                }
            }
        })
        this.pdvService.getPdvInfo().subscribe(
            (pdv: any) => {
                this.pdv = pdv.name;
            }
        )
        this.pdvService.getAuthorizedCities().subscribe(
            (authorizedCities: any[]) => {
                this.authorizedCities = authorizedCities;
            }
        );
    }
}
